import { render, staticRenderFns } from "./EditExtra.vue?vue&type=template&id=15c04389&scoped=true&"
import script from "./EditExtra.vue?vue&type=script&lang=ts&"
export * from "./EditExtra.vue?vue&type=script&lang=ts&"
import style0 from "./EditExtra.vue?vue&type=style&index=0&id=15c04389&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c04389",
  null
  
)

export default component.exports